// extracted by mini-css-extract-plugin
module.exports = {"rightCol":"AcceptanceSetup_rightCol__dLriU"};